import { i18n } from '@/lang/index.js'

const wordsMap = {
  coins: () => {
    return i18n.t('lang.commonM.k295')
  }
}

export default wordsMap
